var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "painel-turno-detalhes az-gap-xsmall" },
    [
      _vm.turno.leitura
        ? _c(
            "div",
            {
              staticClass:
                "az-text-secondary az-size-12 painel-turno-detalhes__linha"
            },
            [_vm._v(" " + _vm._s(_vm.turno.leitura) + " ")]
          )
        : _vm._e(),
      _vm._l(_vm.turno.itens, function(item) {
        return _c(
          "div",
          {
            key: item.chave,
            staticClass: "d-flex align-start flex-wrap az-gap-small"
          },
          [
            _c("BaseStatus", {
              staticClass: "flex-shrink-0",
              attrs: {
                soft: "",
                "preserve-case": "",
                content: item.rotulo,
                color: item.cor
              }
            }),
            _c("div", { staticClass: "painel-turno-detalhes__texto-item" }, [
              _c("span", { staticClass: "az-text-secondary az-size-12" }, [
                _vm._v(_vm._s(item.texto))
              ]),
              item.norma
                ? _c(
                    "span",
                    { staticClass: "az-text-secondary az-size-12 az-muted" },
                    [_vm._v(" — " + _vm._s(item.norma) + " ")]
                  )
                : _vm._e()
            ])
          ],
          1
        )
      }),
      _vm.turno.frase
        ? _c(
            "div",
            {
              staticClass:
                "az-text-secondary az-size-12 painel-turno-detalhes__linha"
            },
            [_vm._v(" " + _vm._s(_vm.turno.frase) + " ")]
          )
        : _vm._e(),
      _vm.turno.ehCondicao
        ? _c(
            "div",
            {
              staticClass:
                "az-text-secondary az-size-12 painel-turno-detalhes__linha"
            },
            [_vm._v(" " + _vm._s(_vm.turno.condicao) + " ")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }